import { Box } from "@mui/material";
import { ReactNode } from "react";

import ModalDialog from "~/components/ModalDialog";
import SpacedGridContainer from "~/components/SpacedGridContainer";
import SpacedGridItem from "~/components/SpacedGridItem";

interface FormModalProps {
	actions?: ReactNode;
	children: ReactNode;
	isHidden?: boolean;
	maxWidth?: string;
	onClose: () => void;
	onSubmit?: () => void;
	open: boolean;
	showCloseButton?: boolean;
	showRequiredIndicator?: boolean;
	title: string;
}

const FormModal = ({
	actions,
	children,
	isHidden,
	maxWidth = "400px",
	onClose,
	onSubmit,
	open,
	showCloseButton = true,
	showRequiredIndicator = false,
	title
}: FormModalProps) => {
	return (
		<ModalDialog
			close={onClose}
			isHidden={isHidden}
			mergeSlotProps
			onSubmit={onSubmit}
			open={open}
			responsiveWidth
			showCloseButton={showCloseButton}
			showRequiredIndicator={showRequiredIndicator}
			slotProps={{
				paper: {
					sx: {
						maxWidth,
						width: "100%"
					}
				}
			}}
			title={title}
		>
			<SpacedGridContainer>
				<SpacedGridItem maxCols={1}>{children}</SpacedGridItem>
				{actions && (
					<SpacedGridItem maxCols={1}>
						<Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>{actions}</Box>
					</SpacedGridItem>
				)}
			</SpacedGridContainer>
		</ModalDialog>
	);
};

export default FormModal;
